/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RequestPhotosOfMissingFreightEmailDefaultContent
 */
export interface RequestPhotosOfMissingFreightEmailDefaultContent {
  /**
   *
   * @type {string}
   * @memberof RequestPhotosOfMissingFreightEmailDefaultContent
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof RequestPhotosOfMissingFreightEmailDefaultContent
   */
  body: string;
}

/**
 * Check if a given object implements the RequestPhotosOfMissingFreightEmailDefaultContent interface.
 */
export function instanceOfRequestPhotosOfMissingFreightEmailDefaultContent(
  value: object,
): value is RequestPhotosOfMissingFreightEmailDefaultContent {
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function RequestPhotosOfMissingFreightEmailDefaultContentFromJSON(
  json: any,
): RequestPhotosOfMissingFreightEmailDefaultContent {
  return RequestPhotosOfMissingFreightEmailDefaultContentFromJSONTyped(
    json,
    false,
  );
}

export function RequestPhotosOfMissingFreightEmailDefaultContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RequestPhotosOfMissingFreightEmailDefaultContent {
  if (json == null) {
    return json;
  }
  return {
    subject: json["subject"],
    body: json["body"],
  };
}

export function RequestPhotosOfMissingFreightEmailDefaultContentToJSON(
  json: any,
): RequestPhotosOfMissingFreightEmailDefaultContent {
  return RequestPhotosOfMissingFreightEmailDefaultContentToJSONTyped(
    json,
    false,
  );
}

export function RequestPhotosOfMissingFreightEmailDefaultContentToJSONTyped(
  value?: RequestPhotosOfMissingFreightEmailDefaultContent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    subject: value["subject"],
    body: value["body"],
  };
}
